export class MessageException extends Error {
    public getMessage(): string {
        return this.message;
    }
}
